import { Api } from "../../Api";

export const getOwnerNFTsService = async (
  walletAddress: string = "",
  token: string = ""
) => {
  let url = `/ownerNft/getUserNft?address=${walletAddress}`;
  const response = await Api.get(url, {
    headers: {
      Authorization: `Bearer ${token}`, // Add the Bearer token here
    },
  });
  return response;
};

export const getWalletBalanceService = async (
  walletAddress: string = "",
  chain: string = ""
) => {
  let url = `/ownerNft/getWalletBlncAndTrans?walletAddress=${walletAddress}&chain=${chain}`;
  const response = await Api.get(url);
  return response;
};

export const syncOwnerNFTsService = async (walletAddress: string = "") => {
  let url = `/ownerNft/userNftSync?address=${walletAddress}`;
  const response = await Api.get(url);
  return response;
};

export const getTrendingNFTsService = async (
  limit: number = 10,
  page: number = 1,
  name: string = "",
  blockchain_network: string = "",
  rank_by: string = "",
  category_id: string,
  eco_category_id: string
) => {
  const payload = {
    ...(name && { name }),
    ...(blockchain_network && { blockchain_network }),
    ...(rank_by && { rank_by }),
    ...(category_id && { category_id }),
    ...(eco_category_id && { eco_category_id }),
  };
  let url = `/nft/trending-nft?limit=${limit}&page=${page}`;
  const response = await Api.post(url, payload);
  return response;
};
